import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import React from 'react';
import { ToolTip } from '../ToolTip';

/**
 * Renders a single radio button. If label is passed in as markup instead of a
 * string, that will replace the standard <span>.
 */
export default function Radio(props) {
  return React.createElement("label", {
    className: "ra ".concat(props.className || ''),
    style: props.style
  }, React.createElement("input", {
    name: props.name,
    value: props.value,
    type: "radio",
    className: "ra-f",
    checked: props.checked,
    onChange: props.onChange,
    onBlur: props.onBlur
  }), typeof props.label === 'string' ? React.createElement("span", {
    className: "ra-l"
  }, props.label) : props.label);
}

/**
 * Render a collection of radio buttons by providing an array of radio item
 * information objects.
 *
 * Group label must be included; if it should be visually hidden, its text is
 * added as an aria-label.
 *
 * If checked value is coming from a parent, pass it in as "checkedValue" prop.
 */
export function RadioGroup(props) {
  var ariaProps = {};
  props.hideLabel ? ariaProps['aria-label'] = props.groupLabel : ariaProps['aria-labelledby'] = "".concat(props.name, "-groupLabel");
  var softRequiredCss = {
    paddingLeft: '0.25em',
    display: 'flex'
  };
  return React.createElement("div", _extends({
    role: "group",
    className: props.className,
    style: props.style
  }, ariaProps), !props.hideLabel && React.createElement("div", {
    className: "txt-l",
    id: "".concat(props.name, "-groupLabel"),
    style: {
      display: 'flex'
    }
  }, props.groupLabel, props.softRequired && React.createElement("span", {
    className: "t--req",
    style: softRequiredCss
  }, "Required"), props.toolTip && ToolTip({
    icon: props.toolTip.icon,
    msg: props.toolTip.msg
  })), props.items.map(function (item, index) {
    return React.createElement(Radio, {
      key: "radio-".concat(index),
      name: props.name,
      label: item.label,
      value: item.value,
      checked: props.checkedValue ? item.value === props.checkedValue : item.checked,
      onChange: props.handleItemChange,
      onBlur: props.handleItemBlur,
      className: "".concat(props.itemsClassName || '', " ").concat(item.className || ''),
      style: props.itemsStyle
    });
  }));
}